import Api from '../../api'
import {
  showInviteSuccessModal,
  hideLoader,
} from 'portal-modules/common/redux/modules/toggleSuccessModals'
import { call, select, takeLatest, put, takeEvery } from 'redux-saga/effects'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import createRequestSaga, {
  handleResponseError,
} from 'portal-modules/common/redux/create-request-saga'
import getProjectName from 'portal-modules/common/utils/get-project-name'
import { PHONE_TYPE_IDS } from 'portal-modules/common/constants/types'
// action types
const ADD_USER_DETAILS = 'rp/users/ADD_USER_DETAILS'
const ADD_USER_PERMISSIONS = 'rp/users/ADD_USER_PERMISSIONS'
const SEND_INVITE = 'rp/users/SEND_INVITE'
const SEND_INVITATION = 'rp/users/SEND_INVITATION'
const INVITATION_SENT = 'rp/users/INVITATION_SENT'
const UPDATE_USER_DETAILS = 'rp/users/UPDATE_USER_DETAILS'
const UPDATE_USER_PERMISSIONS = 'rp/users/UPDATE_USER_PERMISSIONS'
const RESET_DETAILS = 'rp/users/RESET_DETAILS'

// reducer
export default (
  state = { user_details: [], user_permissions: [] },
  { payload, type },
) => {
  switch (type) {
    case ADD_USER_DETAILS:
      return { ...state, user_details: payload }
    case ADD_USER_PERMISSIONS:
      return { ...state, user_permissions: payload }
    case SEND_INVITE:
      return {
        ...state,
        ...payload,
      }
    case INVITATION_SENT:
      return {
        ...state,
        ...payload,
      }
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        ...payload,
      }
    case UPDATE_USER_PERMISSIONS:
      return {
        ...state,
        ...payload,
      }
    case RESET_DETAILS:
      return { user_details: [], user_permissions: [] }
    default:
      return state
  }
}

// action creators
export const addUserDetails = payload => ({ type: ADD_USER_DETAILS, payload })

export const resetUserDetailsAndPermission = () => ({ type: RESET_DETAILS })

export const addUserPermissions = payload => ({
  type: ADD_USER_PERMISSIONS,
  payload,
})

export const sendInvite = createFormAction(SEND_INVITE)

export const updateUserDeatils = createFormAction(UPDATE_USER_DETAILS)

export const updateUserPermissions = createFormAction(UPDATE_USER_PERMISSIONS)

export const sendInvitation = (payload, callback) => ({
  type: SEND_INVITATION,
  payload,
  callback,
})

export function* postSendInvite({ payload, callback, ...rest }) {
  const {
    inviteUser: { user_details, user_permissions },
    user: { cid },
  } = yield select()

  const contact_permissions = {}

  user_permissions?.map(user_permission => {
    user_permission.value.map(item => {
      if (item.isEnabled) {
        contact_permissions[item.key] = ['read', 'write']
      }
    })
  })

  let phone_number_arr = user_details?.phone_numbers
  let phone_number_type_id, phone_number, phone_locale

  if (Array.isArray(phone_number_arr) && phone_number_arr.length) {
    phone_number_arr.forEach(
      ({ phone_number, is_primary_phone, phone_local, phone_type }, i) => {
        phone_number_arr[
          i
        ].phone_number = `+${phone_local} ${phone_number.replace(
          /[( )-]/g,
          '',
        )}`
        phone_number_arr[i].phone_number_type = PHONE_TYPE_IDS[phone_type]
        phone_number_arr[i].is_primary = is_primary_phone
        if (true == is_primary_phone) {
          phone_number_type_id = PHONE_TYPE_IDS[phone_number_arr[i]?.phone_type]
          phone_number = phone_number_arr[i]?.phone_number
        }
      },
    )
    phone_number_type_id = PHONE_TYPE_IDS[phone_number_arr[0]?.phone_type]
    phone_number = phone_number_arr[0]?.phone_number
    phone_locale = phone_number_arr[0]?.phone_local
  }

  const addUserPayload = {
    first_name: user_details?.first_name,
    last_name: user_details?.last_name,
    maternal_last_name: user_details?.maternal_last_name || '',
    email_address: user_details?.email_address,
    phone_number: `+${phone_locale} ${phone_number}`,
    phone_number_type_id: phone_number_type_id || 2,
    phone_numbers: phone_number_arr,
    role: user_details?.role,
    customer_connection_type_id: user_details?.customer_connection_type_id,
    is_admin: false,
    permissions: contact_permissions,
    ...(cid && { cid }),
  }

  yield call(Api.addUserDetails, addUserPayload)
}

export function* postInvitationSent({ payload, callback }) {
  const params = {}
  if ('rh' === getProjectName()) {
    params['group_user_id'] = payload
  } else {
    params['tenant_user_id'] = payload
  }

  const success = yield call(Api.sendInvite, params)

  if (success) {
    yield put({ type: INVITATION_SENT })

    yield put(hideLoader())

    yield put(
      showInviteSuccessModal({
        fromProfile: false,
      }),
    )
  }
  typeof callback === 'function' && callback()
}

export function* postUpdateUserDetails({ payload, callback }) {
  yield call(Api.updateUserDetails, payload)
  typeof callback === 'function' && callback()
}

export function* postUpdateUserPermisions({ payload, callback }) {
  yield call(Api.addUserPermissions, payload)
  typeof callback === 'function' && callback()
}

function* watchSendInvite() {
  yield takeEvery(
    SEND_INVITE,
    createRequestSaga(postSendInvite, {
      key: 'inviteUser',
      message: __('Sending invite'),
      successMessage: __('Invite successfully sent'),
      write: true,
    }),
  )
}
function* watchSentInvitation() {
  yield takeLatest(
    SEND_INVITATION,
    createRequestSaga(postInvitationSent, {
      key: 'users',
      message: __('Sending invite to user'),
      write: true,
    }),
  )
}

function* watchUpdateUserDetails() {
  yield takeEvery(
    UPDATE_USER_DETAILS,
    createRequestSaga(postUpdateUserDetails, {
      key: 'inviteUser',
      message: __('Updating User Details'),
      successMessage: __('User Details Updated Successfully'),
      onError: handleUsersError,
      write: true,
    }),
  )
}

function* watchUpdateUserPermissions() {
  yield takeEvery(
    UPDATE_USER_PERMISSIONS,
    createRequestSaga(postUpdateUserPermisions, {
      key: 'inviteUser',
      message: __('Updating User Permissions'),
      successMessage: __('User Permissions Updated Successfully'),
      write: true,
    }),
  )
}

export function* handleUsersError(err) {
  yield call(handleResponseError, err, { key: 'inviteUser' })
}

export const sagas = [
  watchSendInvite,
  watchUpdateUserDetails,
  watchUpdateUserPermissions,
  watchSentInvitation,
]
